import React from 'react';
import TrendBase from '../components/trend/trendBase';

const Port = () => {
  return <TrendBase source='fromPort' />;
};

export default Port;
